"use client";

import { Activity, Newspaper } from "lucide-react";
import { MobileBottomToolRegistration } from "@/components/mobile-bottom-tools";
import PassRateMiniChart from "@/components/article-shell/PassRateMiniChart";
import { REVIEW_LINKS, ReviewBanner } from "@/components/past-exam/reviewLinks";

/**
 * 합격률 페이지(jeongcheogi-pass-rate) 모바일 하단 dock 도구.
 *
 * 데스크탑 셸은 실기 합격률 추이 미니 차트를 좌측 사이드바에, 회차별 리뷰를 우측 사이드바에
 * 두지만, 클래식/모바일(<1024px)에선 사이드바가 없으므로 하단 dock 패널로 "그래프"·"리뷰"를
 * 노출한다. 경로 게이트(isPassRatePage)는 호출부(PostLayout)가 담당하므로 여기선 항상 등록한다.
 *
 * 목차(order 5) 다음, 필기(order 10) 앞에 그래프(6)·리뷰(7) 순으로 자리한다.
 */
export default function PassRateMobileTools() {
  return (
    <>
      <MobileBottomToolRegistration
        tool={{
          id: "pass-rate-chart",
          kind: "panel",
          label: "그래프",
          icon: Activity,
          order: 6,
          ariaLabel: "실기 합격률 추이 그래프 열기",
          sheet: {
            title: "실기 합격률 추이",
            // 차트(고정 140px)+칩+캡션이 자연 높이라 resizable 로 큰 기본 높이를 잡으면
            // 아래가 텅 빈다. 비-resizable 시트는 height auto 라 콘텐츠만큼만 차지(콘텐츠 hug).
            // attached 로 목차·필기처럼 dock 에 붙여(full-width·위만 둥글게) 렌더한다.
            resizable: false,
            attached: true,
            content: <PassRateMiniChart />,
          },
        }}
      />
      <MobileBottomToolRegistration
        tool={{
          id: "pass-rate-review",
          kind: "panel",
          label: "리뷰",
          icon: Newspaper,
          order: 7,
          ariaLabel: "회차별 실기 후기 열기",
          sheet: {
            // 후기 배너도 자연 높이라 콘텐츠 hug. 넘치면 시트 maxHeight 안에서 스크롤.
            // attached 로 목차·필기처럼 dock 에 붙여 렌더한다.
            title: "회차별 리뷰",
            resizable: false,
            attached: true,
            content: (
              <div className="flex flex-col gap-2">
                {REVIEW_LINKS.map((review) => (
                  <ReviewBanner key={review.href} review={review} />
                ))}
              </div>
            ),
          },
        }}
      />
    </>
  );
}
